import type { Component } from 'solid-js'
import { Show } from 'solid-js'
import type { SongData } from '../../../features/engagement/domain/models/songs'
import Music from '../../../assets/icons/Music'
import ValueProgressCell from './custom-cells/ValueProgressCell'
import { KPI, KPIType } from '../../../features/analytics/domain/models/kpi'
import { NumericalDataType } from '../../../shared/models/numerical-data-type'

export interface SongsTableRowProps {
  readonly song: SongData
  readonly rowNumber: number
}

const SongsTableRow: Component<SongsTableRowProps> = (props) => {
  const calcPrevValue = (value: number | undefined, ratio: number): number | undefined => {
    if (value === undefined) {
      return undefined
    }

    const divisor = 1 + ratio
    if (divisor === 0) {
      return undefined
    }

    return value / divisor
  }

  const timesPlayedKPI = () =>
    new KPI(
      KPIType.TimesPlayed,
      props.song.timesPlayed,
      NumericalDataType.Units,
      props.song.timesPlayedChange,
      calcPrevValue(props.song.timesPlayed, props.song.timesPlayedChange)
    )

  const uniqueListenersKPI = () =>
    new KPI(
      KPIType.UniqueListeners,
      props.song.uniqueListeners,
      NumericalDataType.Units,
      props.song.uniqueListenersChange,
      calcPrevValue(props.song.uniqueListeners, props.song.uniqueListenersChange)
    )

  return (
    <tr class="hover:bg-gray-50">
      <td class="whitespace-nowrap border-r border-gray-200 px-3   py-3.5 text-center text-sm text-gray-700">
        {props.rowNumber}
      </td>
      <td>
        <div class="flex items-center gap-3">
          <Show when={props.song.imageUrl && props.song.imageUrl !== ''} fallback={<Music size={5} />}>
            <img src={props.song.imageUrl!} alt={props.song.name} class="h-5 w-5 flex-shrink-0 rounded object-cover" />
          </Show>
          <span class="text-sm font-medium text-gray-900">{props.song.name}</span>
        </div>
      </td>
      <td class="w-[188px]">
        <ValueProgressCell kpi={timesPlayedKPI()} />
      </td>
      <td class="w-[188px]">
        <ValueProgressCell kpi={uniqueListenersKPI()} />
      </td>
    </tr>
  )
}

export default SongsTableRow
